export default __webpack_public_path__ + "media/newsletter-bg.5a2d6729.svg";